import React, { Fragment, FunctionComponent, Suspense, useMemo } from 'react'
import { Spinner, Text, Tab } from '@chakra-ui/react'
import {
  Rental_Applications_Bool_Exp,
  useUpupRentalApplicationsCountQuery
} from 'graphql/generated'
import { Tag } from 'ui'
import { Comparators } from 'lib/hasura-comparators'
import { merge } from 'lodash'

type Props = {
  label: string
  partial: Rental_Applications_Bool_Exp | null
  active: boolean
  methodology: 'upandup' | 'saferent'
}

const FilterTab: FunctionComponent<React.PropsWithChildren<Props>> = ({
  label,
  partial,
  active,
  methodology
}) => {
  return (
    <Tab gap={2} px={2}>
      <Text fontSize='sm' whiteSpace='nowrap'>
        {label}
      </Text>
      <Suspense fallback={<Spinner />}>
        <Tag bg={active ? 'indigo.100' : undefined} color={active ? 'indigo.600' : undefined}>
          <Count partial={partial} methodology={methodology} />
        </Tag>
      </Suspense>
    </Tab>
  )
}

const Count: FunctionComponent<React.PropsWithChildren<Pick<Props, 'partial' | 'methodology'>>> = ({
  partial,
  methodology
}) => {
  const where = useMemo(
    () =>
      merge({}, partial || {}, {
        underwriting_methodology: Comparators.isEqual(methodology)
      } as Rental_Applications_Bool_Exp),
    [partial, methodology]
  )

  const [{ data, error }] = useUpupRentalApplicationsCountQuery({
    variables: { where }
  })
  if (error) {
    return <div>😢</div>
  }
  return <Fragment>{data?.rental_applications_aggregate.aggregate?.count}</Fragment>
}

export default FilterTab
